import styled from "styled-components";

export const TOAST_CONTAINER_CLASSNAME = "toast";

export const IconContainer = styled.div(() => ({
    display: "flex",
}));

export const ToastContainer = styled.div(({ theme }) => ({
    [`& .${TOAST_CONTAINER_CLASSNAME}`]: {
        bottom: theme.spacing.xLarge,
        left: theme.spacing.medium,
        right: theme.spacing.medium,
        zIndex: 9,
    },
}));
